import React, { PureComponent } from "react";
import { injectIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Message, List } from "semantic-ui-react";
import { ModalTemplate, Loading, Button as Btn } from "components";

import * as common from "libs/commonFunc";
import * as eduTemplateActions from "modules/eduTemplate";

class EduTemplateDelete extends PureComponent {
  state = {
    loading: false,
  };

  onDeleteEduTemplate = async () => {
    try {
      this.setState({ loading: true });

      const { EduTemplateActions, dataInfo } = this.props;
      await EduTemplateActions.deleteEduTemplate({ eduAttachNo: dataInfo.eduAttachNo });

      this.setState({ loading: false });
    } catch (error) {
      console.log("onDeleteEduTemplate", error);
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { dataInfo, toggleModal } = this.props;
    const { eduAttachNo, attachName, regEpoch } = dataInfo;
    const { loading } = this.state;
    const { onDeleteEduTemplate } = this;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={"modal-admin tiny common-content"}
        closeIcon
        onToggleModal={toggleModal}
        visible
        header={<div>{defineMessages(formatMessage({ id: "EduTemplate_10", defaultMessage: "교육 템플릿 삭제" }))}</div>}
        buttons={
          <div className={"inline-block"}>
            <Btn buttonColor="#bbbbbb" onClick={toggleModal}>
              {defineMessages(formatMessage({ id: "ModalEdu_1", defaultMessage: "취 소" }))}
            </Btn>
            <Btn className={"gray-button"} loading={loading} disabled={loading} onClick={onDeleteEduTemplate}>
              {defineMessages(formatMessage({ id: "ModalEdu_5", defaultMessage: "삭 제" }))}
            </Btn>
          </div>
        }
      >
        <Loading active={loading} size="small" content={defineMessages(formatMessage({ id: "AdminUserDelete_4", defaultMessage: "삭제중..." }))} />
        <div className={"message-header"}>
          {defineMessages(
            formatMessage({
              id: "ExamTemplateDelete_5",
              defaultMessage: "삭제한 템플릿은 복구할 수 없습니다.",
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: "ExamTemplateDelete_9",
              defaultMessage: "다음 템플릿을 삭제합니까?",
            })
          )}
        </div>
        <Message className={"template-detail-box"}>
          <div className={"template-detail"}>
            <List bulleted className={"template-detail-list"}>
              <List.Item className={"template-detail-item"}>
                <div className={"template-detail-item-title"}>No</div>
                {eduAttachNo}
              </List.Item>
              <List.Item className={"template-detail-item"}>
                <div className={"template-detail-item-title"}>{defineMessages(formatMessage({ id: "EduTemplate_1", defaultMessage: "컨텐츠명" }))}</div>
                {attachName}
              </List.Item>
              <List.Item className={"template-detail-item"}>
                <div className={"template-detail-item-title"}>{defineMessages(formatMessage({ id: "AdminUserDelete_7", defaultMessage: "등록일시" }))}</div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  EduTemplateActions: bindActionCreators(eduTemplateActions, dispatch),
});

export default connect(null, mapDispatchToProps)(injectIntl(EduTemplateDelete));
// export default injectIntl(EduTemplateDelete);



// WEBPACK FOOTER //
// ./src/script/components/eduTemplate/EduTemplateDelete.js